import './app.css';
import RespMenu from './modules/RespMenu';
import ScrollTo from './modules/ScrollTo';

class Index {
  constructor() {
    let menuEl = document.querySelector('nav .menu.list');

    if (menuEl) {
      new RespMenu(menuEl);
    }
    new ScrollTo();
  }
}


window.addEventListener('load', new Index());



// WEBPACK FOOTER //
// ./app.js